// @ts-nocheck
document.addEventListener("DOMContentLoaded", function () {
  const widthFeet = localStorage.getItem("WidthFeet");
  const widthInches = localStorage.getItem("WidthInches");
  const lengthFeet = localStorage.getItem("LengthFeet");
  const lengthInches = localStorage.getItem("LengthInches");

  const isAnyValuePresent =
    widthFeet || widthInches || lengthFeet || lengthInches;

  if (isAnyValuePresent) {
    setTimeout(() => {
      const rectangleBtn = document.querySelector("#CustomRugshape-rectangle");
      const squareBtn = document.querySelector("#CustomRugshape-square");
      if (squareBtn) {
        squareBtn.click();
      }
      if (rectangleBtn) {
        rectangleBtn.click();
      } else {
        return;
      }

      const widthFeetInput = document.querySelector(
        'input[name="properties[width-feet]"]'
      );
      const widthInchesInput = document.querySelector(
        'input[name="properties[width-inches]"]'
      );
      const lengthFeetInput = document.querySelector(
        'input[name="properties[length-feet]"]'
      );
      const lengthInchesInput = document.querySelector(
        'input[name="properties[length-inches]"]'
      );

      // Helper function to set the input value and dispatch a 'change' event
      function setInputValueAndDispatchEvent(inputElement, value) {
        if (inputElement && value !== null) {
          inputElement.value = value;
          const event = new Event("change", { bubbles: true });
          inputElement.dispatchEvent(event);
        }
      }

      setInputValueAndDispatchEvent(widthFeetInput, widthFeet);
      setInputValueAndDispatchEvent(widthInchesInput, widthInches);
      setInputValueAndDispatchEvent(lengthFeetInput, lengthFeet);
      setInputValueAndDispatchEvent(lengthInchesInput, lengthInches);

      // Your existing Cylindo element hiding logic
      const element = document.querySelector(
        '[cylindo-variant-selector="Size"]'
      );
      setTimeout(() => {
        if (element) {
          element.querySelector(".cylindoVariant__options").style.overflow =
            "hidden";
          element.querySelector(".cylindoVariant__options").style.height = "0";
        }
      }, 100);
    }, 500);
  }
});

// Accessiblility Js
document.querySelectorAll(".nav__menuItem").forEach((item) => {
  const link = item.querySelector(".nav__link");

  item.addEventListener("mouseenter", () => {
    link.setAttribute("aria-expanded", "true");
  });

  item.addEventListener("mouseleave", () => {
    link.setAttribute("aria-expanded", "false");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var el = document.getElementById("shopify-section-footer");
  if (el) el.setAttribute("role", "contentinfo");
});
function updateSlideVisibility() {
  document.querySelectorAll('.swiper-slide').forEach(slide => {
    const variant = slide.querySelector('.cylindoVariant__option');
    if (variant) {
      const availability = variant.getAttribute('data-availability');
      if (availability === 'false') {
        slide.style.display = 'none';
      } else {
        slide.style.display = '';
      }
    }
  });
}
setTimeout(updateSlideVisibility, 1000);

const observer_mutation = new MutationObserver(mutations => {
  for (const mutation of mutations) {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'data-availability'
    ) {
      updateSlideVisibility();
      break;
    }
  }
});

function observeVariants() {
  document.querySelectorAll('.cylindoVariant__option').forEach(variant => {
    observer_mutation.observe(variant, { attributes: true });
  });
}
setTimeout(observeVariants, 1000);

// sub-category on collection page

document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".sub-category-menu-wrapper");
  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const scroller = wrapper.querySelector(".sub-category-menu");
    const btnLeft = wrapper.querySelector(".sub-cat-arrow--left");
    const btnRight = wrapper.querySelector(".sub-cat-arrow--right");
    if (!scroller || !btnLeft || !btnRight) return;


    const getScrollStep = () => Math.floor(scroller.clientWidth * 0.8);

    const updateArrows = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const atStart = scroller.scrollLeft <= 2;
      const atEnd = scroller.scrollLeft >= maxScroll - 2;

      btnLeft.setAttribute("aria-hidden", atStart);
      btnRight.setAttribute("aria-hidden", atEnd);
      btnLeft.disabled = atStart;
      btnRight.disabled = atEnd;


      if (scroller.scrollWidth <= scroller.clientWidth + 1) {
        btnLeft.setAttribute("aria-hidden", "true");
        btnRight.setAttribute("aria-hidden", "true");
        btnLeft.disabled = true;
        btnRight.disabled = true;
      }
    };

    const scrollByStep = (dir) => {
      scroller.scrollBy({ left: getScrollStep() * dir, behavior: "smooth" });

      clearTimeout(scroller._scrollTimeout);
      scroller._scrollTimeout = setTimeout(updateArrows, 250);
    };


    btnLeft.addEventListener("click", () => scrollByStep(-1));
    btnRight.addEventListener("click", () => scrollByStep(1));


    let ticking = false;
    scroller.addEventListener("scroll", () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateArrows();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });


    window.addEventListener("resize", () => {
      clearTimeout(scroller._resizeTimeout);
      scroller._resizeTimeout = setTimeout(updateArrows, 150);
    });


    scroller.addEventListener("focusin", (e) => {
      const el = e.target;
      if (!el || !scroller.contains(el)) return;
      const left = el.offsetLeft;
      const right = left + el.offsetWidth;
      if (left < scroller.scrollLeft) {
        scroller.scrollTo({ left: left - 12, behavior: "smooth" });
      } else if (right > scroller.scrollLeft + scroller.clientWidth) {
        scroller.scrollTo({ left: right - scroller.clientWidth + 12, behavior: "smooth" });
      }
    });

    scroller.scrollLeft = 0;
    setTimeout(updateArrows, 80);
  });
});

// end sub-category

// Handle variant media gallery with custom.media_gallery metafield
(function () {
  'use strict';

  // Parse ProductGalleryData from the page
  function getProductGalleryData() {
    try {
      const script = document.getElementById('ProductGalleryData');
      if (script) {
        return JSON.parse(script.textContent);
      }
    } catch (e) {
      // Error parsing ProductGalleryData
    }
    return null;
  }

  // Update gallery to show custom.media_gallery images if available
  /**
   * @param {number} variantId
   * @param {number} [retryCount=0]
   * @returns {boolean}
   */
  function updateGalleryWithMetafield(variantId, retryCount = 0) {
    const galleryData = getProductGalleryData();

    if (!galleryData || !galleryData.variantGalleries) {
      // Retry if gallery data not ready yet (max 5 retries = 2.5 seconds)
      if (retryCount < 5) {
        setTimeout(() => updateGalleryWithMetafield(variantId, retryCount + 1), 500);
      }
      return false;
    }

    // Check if variant has custom gallery images in ProductGalleryData
    const variantGallery = galleryData.variantGalleries[variantId];

    if (variantGallery && Array.isArray(variantGallery) && variantGallery.length > 0) {

      // Get the main gallery slides
      const mainGalleryWrapper = document.querySelector('.product-gallery__main .swiper-wrapper');
      const thumbGalleryWrapper = document.querySelector('.product-gallery__thumbs .swiper-wrapper');

      // Check if gallery wrappers exist and have slides
      if (!mainGalleryWrapper || !thumbGalleryWrapper) {
        // Retry if gallery not ready yet (max 5 retries = 2.5 seconds)
        if (retryCount < 5) {
          setTimeout(() => updateGalleryWithMetafield(variantId, retryCount + 1), 500);
        }
        return false;
      }

      // Check if there are any slides in the gallery (gallery might not be initialized yet)
      const mainSlides = mainGalleryWrapper.querySelectorAll('.swiper-slide');
      const thumbSlides = thumbGalleryWrapper.querySelectorAll('.swiper-slide');
      const hasSlides = mainSlides.length > 0;

      if (!hasSlides && retryCount < 5) {
        // Retry if slides not ready yet
        setTimeout(() => updateGalleryWithMetafield(variantId, retryCount + 1), 500);
        return false;
      }

      // Guard: If product-gallery.js has already replaced the Liquid-rendered slides
      // with JS-generated slides for this variant, skip the display:none manipulation.
      // JS-generated slides (from product-gallery.js → SlideElements()) do NOT carry the
      // [gallery-media-default] attribute, which is only present on Liquid-rendered slides.
      // Running display:none on JS-generated slides causes a race condition where slides
      // get hidden but the ID-based re-show logic fails (different image URL formats).
      const hasLiquidRenderedSlides = mainGalleryWrapper.querySelector('.swiper-slide[gallery-media-default]') !== null;
      if (!hasLiquidRenderedSlides) {
        return false;
      }

      // Hide all images in main gallery (EXCEPT dimension slide)
      const allMainImages = mainGalleryWrapper.querySelectorAll('.swiper-slide:not([gallery-media-dimension])');
      allMainImages.forEach(slide => {
        slide.style.display = 'none';
      });

      // Hide all thumbnails (EXCEPT dimension slide)
      const allThumbImages = thumbGalleryWrapper.querySelectorAll('.swiper-slide:not([gallery-media-dimension])');
      allThumbImages.forEach(slide => {
        slide.style.display = 'none';
      });

      // Always show dimension slide if it exists
      const dimensionMainSlide = mainGalleryWrapper.querySelector('[gallery-media-dimension]');
      const dimensionThumbSlide = thumbGalleryWrapper.querySelector('[gallery-media-dimension]');
      if (dimensionMainSlide) {
        dimensionMainSlide.style.display = '';
      }
      if (dimensionThumbSlide) {
        dimensionThumbSlide.style.display = '';
      }

      // Show only the images that match the custom.media_gallery
      // Try multiple possible ID properties: id, media_id, preview.image.id, etc.
      const customMediaIds = variantGallery.map(media => {
        // Try different possible ID properties
        return media.id || media.media_id || media.preview?.image?.id || media.image?.id || media.src?.split('/').pop()?.split('?')[0];
      }).filter(id => id != null);

      let foundMainCount = 0;
      let foundThumbCount = 0;

      // Try to match by ID first, then by URL/src if ID doesn't match
      variantGallery.forEach((mediaObj, index) => {
        const mediaId = mediaObj.id || mediaObj.media_id;
        const mediaUrl = mediaObj.url || mediaObj.src;

        // Try to find by data-thumbnail-id first
        let mainImage = mainGalleryWrapper.querySelector(`[data-thumbnail-id="${mediaId}"]`);
        let thumbImage = thumbGalleryWrapper.querySelector(`[data-thumbnail-id="${mediaId}"]`);

        // If not found by ID, try to find by image src/url
        if (!mainImage && mediaUrl) {
          // Extract base URL from mediaUrl (remove query params and transformations)
          const baseUrl = mediaUrl.split('?')[0].split('/').pop();
          // Try to find slide by matching image src
          const allMainSlides = mainGalleryWrapper.querySelectorAll('.swiper-slide');
          for (const slide of allMainSlides) {
            const img = slide.querySelector('img');
            if (img && (img.src.includes(baseUrl) || img.dataset.src?.includes(baseUrl) || img.getAttribute('srcset')?.includes(baseUrl))) {
              mainImage = slide;
              break;
            }
          }
        }

        if (!thumbImage && mediaUrl) {
          const baseUrl = mediaUrl.split('?')[0].split('/').pop();
          const allThumbSlides = thumbGalleryWrapper.querySelectorAll('.swiper-slide');
          for (const slide of allThumbSlides) {
            const img = slide.querySelector('img');
            if (img && (img.src.includes(baseUrl) || img.dataset.src?.includes(baseUrl) || img.getAttribute('srcset')?.includes(baseUrl))) {
              thumbImage = slide;
              break;
            }
          }
        }

        // Show main gallery image
        if (mainImage) {
          mainImage.style.display = '';
          foundMainCount++;
          // Set as active slide if it's the first one
          if (index === 0 && mainImage.classList.contains('swiper-slide')) {
            mainImage.classList.add('swiper-slide-active');
          }
        }

        // Show thumbnail
        if (thumbImage) {
          thumbImage.style.display = '';
          foundThumbCount++;
          // Set as active thumbnail if it's the first one
          if (index === 0 && thumbImage.classList.contains('swiper-slide')) {
            thumbImage.classList.add('swiper-slide-active');
          }
        }
      });

      // If no matches were found, restore all slides and do not force a filtered gallery.
      if (foundMainCount === 0 && foundThumbCount === 0) {
        allMainImages.forEach(slide => {
          slide.style.display = '';
        });
        allThumbImages.forEach(slide => {
          slide.style.display = '';
        });
        return false;
      }

      // Update swiper slides to first visible image
      setTimeout(() => {
        const mainSwiper = mainGalleryWrapper.closest('.swiper')?.swiper;
        const thumbsSwiper = thumbGalleryWrapper.closest('.swiper')?.swiper;

        if (mainSwiper) {
          // Find first visible slide index
          const visibleSlides = Array.from(mainSwiper.slides).filter(slide => {
            const slideEl = /** @type {HTMLElement} */ (slide);
            return slideEl.style.display !== 'none';
          });
          if (visibleSlides.length > 0) {
            const firstVisibleIndex = Array.from(mainSwiper.slides).indexOf(visibleSlides[0]);
            mainSwiper.slideTo(firstVisibleIndex, 0);
          }
        }
        if (thumbsSwiper) {
          // Find first visible thumb index
          const visibleThumbs = Array.from(thumbsSwiper.slides).filter(slide => {
            const slideEl = /** @type {HTMLElement} */ (slide);
            return slideEl.style.display !== 'none';
          });
          if (visibleThumbs.length > 0) {
            const firstVisibleIndex = Array.from(thumbsSwiper.slides).indexOf(visibleThumbs[0]);
            thumbsSwiper.slideTo(firstVisibleIndex, 0);
          }
        }

        updateArrowStates();
      }, 50);

      return true;
    }

    return false;
  }

  // Listen for variant change events
  document.addEventListener('flu:product:variant-change', function (evt) {
    if (evt.detail && evt.detail.variant) {
      const variant = evt.detail.variant;
      const variantId = variant.id;

      // Try to update gallery with custom media gallery
      const updated = updateGalleryWithMetafield(variantId);

      // If no custom media gallery was found, let the default behavior handle it
    }
  });

  // Also listen for the custom variant change events used by the new system
  document.addEventListener('variant:changed', function (event) {
    // Get variant ID from event detail (preferred method)
    let variantId = null;
    if (event.detail && event.detail.variantId) {
      variantId = parseInt(event.detail.variantId);
    } else if (event.detail && event.detail.variant && event.detail.variant.id) {
      variantId = parseInt(event.detail.variant.id);
    } else {
      // Fallback: Try to get the currently selected variant from the form
      const form = document.querySelector('[data-product-form]');
      if (form) {
        const variantSelect = form.querySelector('select[name="id"]');
        if (variantSelect && variantSelect.value) {
          variantId = parseInt(variantSelect.value);
        }
      }

      // Another fallback: Try to get from variant-picker custom element
      if (!variantId) {
        const variantPicker = document.querySelector('variant-picker');
        if (variantPicker && variantPicker.currentVariant) {
          variantId = variantPicker.currentVariant.id;
        }
      }
    }

    if (variantId) {
      // Add a small delay to ensure gallery has finished updating with default slides
      // This is especially important for furniture_new where revertToDefaultMedia is called first
      setTimeout(() => {
        updateGalleryWithMetafield(variantId);
      }, 100);
    }
  });

  // Initial load: Update gallery for selected variant on furniture_new template
  function initializeGalleryOnLoad() {
    // Check if this is a furniture_new product page
    const productGalleryEl = document.querySelector('[product-gallery]');
    const isFurnitureNew = (productGalleryEl?.dataset?.templateSuffix === 'furniture_new') ||
      (document.body.classList.contains('template-product') &&
        window.location.pathname.includes('furniture'));

    if (!isFurnitureNew) {
      return;
    }

    // Wait for variant-picker and gallery to initialize
    // Use a longer delay to ensure gallery is fully initialized with all default slides
    setTimeout(() => {
      let variantId = null;

      // Try to get variant ID from URL
      const urlParams = new URLSearchParams(window.location.search);
      const urlVariantId = urlParams.get('variant');
      if (urlVariantId) {
        variantId = parseInt(urlVariantId);
      }

      // Fallback: Get from variant-picker
      if (!variantId) {
        const variantPicker = document.querySelector('variant-picker');
        if (variantPicker && variantPicker.currentVariant) {
          variantId = variantPicker.currentVariant.id;
        }
      }

      // Fallback: Get from form
      if (!variantId) {
        const form = document.querySelector('[data-product-form]');
        if (form) {
          const variantSelect = form.querySelector('select[name="id"]');
          if (variantSelect && variantSelect.value) {
            variantId = parseInt(variantSelect.value);
          }
        }
      }

      // Update gallery if variant found
      // updateGalleryWithMetafield has its own retry mechanism, so we can call it directly
      if (variantId) {
        updateGalleryWithMetafield(variantId);
      }
    }, 1000); // Increased delay to 1000ms to ensure gallery is fully initialized
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGalleryOnLoad);
  } else {
    initializeGalleryOnLoad();
  }

  // Also try on window load as fallback (in case script loads late)
  window.addEventListener('load', function () {
    const productGalleryEl = document.querySelector('[product-gallery]');
    const isFurnitureNew = (productGalleryEl?.dataset?.templateSuffix === 'furniture_new') ||
      (document.body.classList.contains('template-product') &&
        window.location.pathname.includes('furniture'));
    if (isFurnitureNew) {
      initializeGalleryOnLoad();
    }
  });
})();
// Custom main gallery navigation arrows
(function () {
  'use strict';

  let mainSwiper = null;
  let thumbsSwiper = null;

  function getSwiperInstances() {
    if (!mainSwiper) {
      const mainSwiperEl = document.querySelector('.product-gallery__main .swiper');
      if (mainSwiperEl && mainSwiperEl.swiper) {
        mainSwiper = mainSwiperEl.swiper;
      }
    }

    if (!thumbsSwiper) {
      const thumbsSwiperEl = document.querySelector('.product-gallery__thumbs .swiper');
      if (thumbsSwiperEl && thumbsSwiperEl.swiper) {
        thumbsSwiper = thumbsSwiperEl.swiper;
      }
    }

    return { mainSwiper, thumbsSwiper };
  }

  function getVisibleSlides() {
    if (!mainSwiper) return [];
    // Get slides that are not hidden with display:none
    const slides = Array.from(mainSwiper.slides);
    return slides.filter(slide => slide.style.display !== 'none');
  }

  function setNavButtonState(btn, disabled) {
    if (!btn) return;
    btn.classList.remove('swiper-button-lock');
    btn.tabIndex = disabled ? -1 : 0;
    if (disabled) {
      btn.disabled = true;
      btn.classList.add('swiper-button-disabled');
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.disabled = false;
      btn.classList.remove('swiper-button-disabled');
      btn.setAttribute('aria-disabled', 'false');
    }
  }

  function updateArrowStates() {
    const { mainSwiper } = getSwiperInstances();
    const prevBtn = document.querySelector('[data-custom-nav="prev"]');
    const nextBtn = document.querySelector('[data-custom-nav="next"]');

    if (!prevBtn || !nextBtn) return;

    // If no swiper or slides, disable arrows
    if (!mainSwiper || !mainSwiper.slides || mainSwiper.slides.length === 0) {
      setNavButtonState(prevBtn, true);
      setNavButtonState(nextBtn, true);
      return;
    }

    const visibleSlides = getVisibleSlides();
    const visibleCount = visibleSlides.length;

    // If only 1 or no visible slides, disable both arrows
    if (visibleCount <= 1) {
      setNavButtonState(prevBtn, true);
      setNavButtonState(nextBtn, true);
      return;
    }

    const activeIndex = mainSwiper.activeIndex;
    const activeSlide = mainSwiper.slides[activeIndex];

    // Find the current position in visible slides array
    const currentVisibleIndex = visibleSlides.indexOf(activeSlide);
    const atStart = currentVisibleIndex <= 0;
    const atEnd = currentVisibleIndex >= visibleCount - 1;

    setNavButtonState(prevBtn, atStart);
    setNavButtonState(nextBtn, atEnd);
  }

  function navigateGallery(direction) {
    const { mainSwiper, thumbsSwiper } = getSwiperInstances();

    if (!mainSwiper) {
      return;
    }

    const currentIndex = mainSwiper.activeIndex;
    const visibleSlides = Array.from(mainSwiper.slides).filter(slide => slide.style.display !== 'none');

    let targetSlide = null;

    if (direction === 'next') {
      // Find next visible slide
      for (let i = currentIndex + 1; i < mainSwiper.slides.length; i++) {
        if (mainSwiper.slides[i].style.display !== 'none') {
          targetSlide = mainSwiper.slides[i];
          break;
        }
      }
    } else if (direction === 'prev') {
      // Find previous visible slide
      for (let i = currentIndex - 1; i >= 0; i--) {
        if (mainSwiper.slides[i].style.display !== 'none') {
          targetSlide = mainSwiper.slides[i];
          break;
        }
      }
    }

    if (targetSlide) {
      const targetIndex = Array.from(mainSwiper.slides).indexOf(targetSlide);
      mainSwiper.slideTo(targetIndex);

      // Also update thumbs swiper if it exists
      if (thumbsSwiper) {
        thumbsSwiper.slideTo(targetIndex);
      }

      setTimeout(updateArrowStates, 100);
    }
  }

  // Initialize on DOM ready
  function init() {
    const prevBtn = document.querySelector('[data-custom-nav="prev"]');
    const nextBtn = document.querySelector('[data-custom-nav="next"]');

    if (!prevBtn || !nextBtn) return;

    // Wait for Swiper to initialize
    setTimeout(() => {
      getSwiperInstances();

      if (!mainSwiper) {
        setTimeout(init, 500);
        return;
      }

      // Add click listeners
      prevBtn.addEventListener('click', () => navigateGallery('prev'));
      nextBtn.addEventListener('click', () => navigateGallery('next'));

      // Update arrow states initially
      updateArrowStates();

      // Listen to swiper slide change events
      if (mainSwiper) {
        mainSwiper.on('slideChange', () => {
          setTimeout(updateArrowStates, 50);
        });
      }

      // Watch for slide visibility changes (when slides are hidden/shown)
      const mainSwiperEl = document.querySelector('.product-gallery__main .swiper');
      if (mainSwiperEl) {
        const observer = new MutationObserver(() => {
          setTimeout(updateArrowStates, 100);
        });

        // Watch for style changes on slides
        const config = {
          attributes: true,
          attributeFilter: ['style'],
          subtree: true,
          childList: true
        };

        observer.observe(mainSwiperEl, config);
      }

      // Update on variant change - with proper re-initialization
      const handleVariantChange = () => {
        // Clear cached instances
        mainSwiper = null;
        thumbsSwiper = null;

        // Wait for slides to be updated (hidden/shown)
        setTimeout(() => {
          // Re-get swiper instances
          const { mainSwiper: newMainSwiper } = getSwiperInstances();

          if (newMainSwiper) {
            // Re-attach slideChange listener to new instance
            newMainSwiper.on('slideChange', () => {
              setTimeout(updateArrowStates, 50);
            });

            // Update swiper to recalculate
            newMainSwiper.update();

            // Update arrow states
            updateArrowStates();
          }
        }, 200);
      };
      document.addEventListener('flu:product:variant-change', handleVariantChange);
      document.addEventListener('variant:changed', handleVariantChange);

      document.addEventListener('product-gallery:updated', () => {
        mainSwiper = null;
        thumbsSwiper = null;
        getSwiperInstances();
        updateArrowStates();
      });
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Fix fabric swatch images by updating them with correct variant data when orientation changes
(function() {
  'use strict';
  let isAutoResettingFabric = false;
  
  // Universal cleanup function to remove background-image from all swatches
  function cleanupSwatchBackgroundImages() {
    // SKIP shop collection items - they have their own handler
    const allSwatches = document.querySelectorAll('.swatch--square, .swatch');
    allSwatches.forEach(swatchSpan => {
      // Skip if inside shop-collection__item
      if (swatchSpan.closest('.shop-collection__item')) {
        return;
      }
      
      const currentStyle = swatchSpan.getAttribute('style') || '';
      if (currentStyle.includes('background-image')) {
        const newStyle = currentStyle.replace(/background-image:\s*url\([^)]*\)\s*;?/gi, '');
        swatchSpan.setAttribute('style', newStyle);
      }
    });
  }
  
  function updateFabricSwatchImages() {
    // SKIP shop collection items - they have their own handler
    const isShopCollectionPage = document.querySelector('.shop-collection__item');
    if (isShopCollectionPage) {
      return;
    }
    
    // Get product variant data
    const variantDataScript = document.getElementById('product-options-variant-data');
    if (!variantDataScript) {
      return;
    }
    
    let productData;
    try {
      productData = JSON.parse(variantDataScript.textContent);
    } catch (e) {
      return;
    }
    
    if (!productData.options || !productData.variants || !productData.options_with_values) {
      return;
    }
    
    // Get currently selected options - build a map by option name
    const selectedOptions = {};
    
    // Method 1: Try from checked radio inputs
    document.querySelectorAll('.product-metas__options fieldset').forEach((fieldset) => {
      const legendEl = fieldset.querySelector('legend.selectOption__label');
      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      
      if (legendEl && checkedInput) {
        const optionName = legendEl.textContent.trim();
        const optionValue = checkedInput.value;
        selectedOptions[optionName] = optionValue;
      }
    });
    
    // Method 2: Fallback to input[name^="options["] if the above didn't work
    if (Object.keys(selectedOptions).length === 0) {
      document.querySelectorAll('input[name^="options["]:checked').forEach(input => {
        const match = input.name.match(/options\[([^\]]+)\]/);
        if (match) {
          selectedOptions[match[1]] = input.value;
        }
      });
    }
    
    // Find Fabric option index
    const fabricOptionIndex = productData.options.findIndex(opt => 
      opt.toLowerCase() === 'fabric' || opt.toLowerCase().includes('color')
    );
    
    if (fabricOptionIndex === -1) {
      return;
    }
    
    const fabricOptionName = productData.options[fabricOptionIndex];
    const fabricOptionsData = productData.options_with_values[fabricOptionIndex];
    
    if (!fabricOptionsData || !fabricOptionsData.values) {
      return;
    }
    
    // Find all fabric swatch elements - try multiple selectors
    // IMPORTANT: Only select color/fabric options, exclude quantity and other options
    const swatchSelectors = [
      '.product-options__option-group--fabric .product-options__option-value',
      '[data-option-name="Fabric"] .product-options__option-value',
      '[data-option-name="Color"] .product-options__option-value',
      '.product-options__option-group--color .product-options__option-value'
    ];
    
    let swatchElements = [];
    for (const selector of swatchSelectors) {
      swatchElements = document.querySelectorAll(selector);
      if (swatchElements.length > 0) {
        break;
      }
    }
    
    // Fallback: If no specific selectors found, try general selector but filter by option name
    if (swatchElements.length === 0) {
      const allOptions = document.querySelectorAll('.product-options__option-group .product-options__option-value');
      swatchElements = Array.from(allOptions).filter(el => {
        const optionName = el.getAttribute('data-option-name') || '';
        const optionNameLower = optionName.toLowerCase();
        return optionNameLower === 'color' || optionNameLower === 'fabric' || optionNameLower.includes('color') || optionNameLower.includes('fabric');
      });
    }
    
    if (swatchElements.length === 0) {
      return;
    }
    
    let updatedCount = 0;
    let hiddenCount = 0;
    let disabledCount = 0;
    const normalizedFabricOptionName = (fabricOptionName || '').toLowerCase();
    const isOptionHidden = (optionEl) => {
      if (!optionEl) return true;
      const computedStyle = window.getComputedStyle(optionEl);
      return computedStyle.display === 'none' || computedStyle.visibility === 'hidden';
    };
    const getOptionInput = (optionEl) => optionEl.querySelector('input[type="radio"], input[type="checkbox"]');
    const isFabricOptionElement = (optionEl) => {
      const optionName = (optionEl.getAttribute('data-option-name') || '').toLowerCase();
      if (!optionName) return false;
      if (optionName === normalizedFabricOptionName) return true;
      if (optionName.includes('fabric')) return true;
      if (normalizedFabricOptionName.includes('color') && optionName.includes('color')) return true;
      return false;
    };
    const isValidFabricOption = (optionEl) => {
      if (!optionEl || !isFabricOptionElement(optionEl) || isOptionHidden(optionEl)) {
        return false;
      }
      if (optionEl.getAttribute('data-availability') === 'false' || optionEl.getAttribute('data-has-available-variant') === 'false') {
        return false;
      }
      const input = getOptionInput(optionEl);
      return !!(input && !input.disabled);
    };
    
    // Update each fabric swatch with correct image and visibility
    swatchElements.forEach(optionEl => {
      // Double check: Only process color/fabric options, skip quantity and others
      const optionName = optionEl.getAttribute('data-option-name') || '';
      const optionNameLower = optionName.toLowerCase();
      if (optionNameLower !== 'color' && optionNameLower !== 'fabric' && !optionNameLower.includes('color') && !optionNameLower.includes('fabric')) {
        return; // Skip non-color/fabric options like quantity
      }
      
      const fabricValue = optionEl.getAttribute('data-option-value');
      if (!fabricValue) return;
      
      // Build the options array for matching: [option1, option2, option3]
      const optionsToMatch = [...productData.options];
      const variantOptions = optionsToMatch.map((optName, idx) => {
        if (idx === fabricOptionIndex) {
          return fabricValue; // Use the fabric value for this swatch
        }
        // Use the selected value for other options
        return selectedOptions[optName] || null;
      });
      
      // Find variant that matches these options
      // If an option is not selected (null), it should match any value (wildcard behavior)
      const matchingVariant = productData.variants.find(variant => {
        return variant.options.every((optVal, idx) => {
          // If this is the color/fabric option, must match exactly
          if (idx === fabricOptionIndex) {
            return optVal === variantOptions[idx];
          }
          // For other options: if not selected (null), match any value (wildcard)
          if (variantOptions[idx] === null) {
            return true; // Match any value for unselected options
          }
          // If selected, must match exactly
          return optVal === variantOptions[idx];
        });
      });
      
      // Check if variant exists for this combination
      const variantExists = !!matchingVariant;
      
      // Check if any other option (like size) is selected
      // If no size is selected, we should enable colors if they have ANY variant
      const hasOtherOptionsSelected = productData.options.some((optName, idx) => {
        if (idx === fabricOptionIndex) return false; // Skip color/fabric option
        return selectedOptions[optName] != null; // Check if this option has a selected value
      });
      
      // Check if variant is available (in stock and not disabled by metafield)
      let isAvailable = false;
      if (matchingVariant) {
        const variantIndex = productData.variants.findIndex(v => v.id === matchingVariant.id);
        const metafields = productData.variants_metafields?.[variantIndex];
        
        // Check availability: variant.available AND metafield.custom.availability !== false
        const metafieldAvailable = !(
          (metafields?.custom?.availability === false) ||
          (metafields?.availability === false)
        );
        
        isAvailable = matchingVariant.available && metafieldAvailable;
      }
      
      // Set data attributes
      optionEl.setAttribute('data-has-available-variant', String(variantExists));
      optionEl.setAttribute('data-availability', String(isAvailable));
      
      if (matchingVariant) {
        optionEl.setAttribute('data-variant-id', matchingVariant.id);
      }
      
      // Apply visibility logic: Hide if variant doesn't exist at all
      if (!variantExists) {
        optionEl.style.setProperty('display', 'none', 'important');
        optionEl.classList.remove('is-disabled');
        
        // Disable input
        const input = optionEl.querySelector('input');
        if (input) {
          input.disabled = true;
        }
        
        hiddenCount++;
        return; // Skip image update for hidden items
      }
      
      // Show the element if variant exists
      optionEl.style.removeProperty('display');
      optionEl.style.display = '';
      
      // Special handling: If no size/other option is selected, enable all colors that have variants
      // If size is selected, use normal availability logic (disable if out of stock)
      let shouldDisable = false;
      if (hasOtherOptionsSelected) {
        // Size is selected: use normal availability logic
        shouldDisable = variantExists && !isAvailable;
      } else {
        // No size selected: enable color if variant exists (regardless of availability)
        // This matches live website behavior where colors are enabled when no size is selected
        shouldDisable = false;
      }
      
      // Add disabled class if variant exists but out of stock (shows strikethrough)
      if (shouldDisable) {
        optionEl.classList.add('is-disabled');
        disabledCount++;
      } else {
        optionEl.classList.remove('is-disabled');
      }
      
      // Enable/disable input based on availability
      const input = optionEl.querySelector('input');
      if (input) {
        // If no size selected, always enable (matches live behavior)
        // If size selected, disable only if variant exists but not available
        input.disabled = shouldDisable;
      }
      
      // Update swatch image
      // Get swatch image URL - Priority: option data-custom-swatch > variant custom swatch metafield > option value swatch > variant featured image
      let swatchImageUrl = null;
      
      const swatchSpan = optionEl.querySelector('.swatch--square, .swatch');
      const normalizeSwatchUrl = (value) => {
        if (!value) return null;
        if (typeof value === 'string') {
          const trimmed = value.trim();
          if (!trimmed) return null;
          const cssUrlMatch = trimmed.match(/^url\((.*)\)$/i);
          if (cssUrlMatch) {
            return cssUrlMatch[1].trim().replace(/^['"]|['"]$/g, '');
          }
          return trimmed;
        }
        if (typeof value === 'object') {
          if (typeof value.url === 'string' && value.url.trim()) return value.url.trim();
          if (typeof value.src === 'string' && value.src.trim()) return value.src.trim();
          if (typeof value.value === 'string' && value.value.trim()) return value.value.trim();
        }
        return null;
      };
      
      // Priority 0: Use option-level swatch carried from Liquid (keeps disabled options visually stable)
      swatchImageUrl = normalizeSwatchUrl(optionEl.getAttribute('data-custom-swatch'));
      
      // Priority 1: Check variant custom swatch metafield (always use if available)
      const variantIndex = matchingVariant
        ? productData.variants.findIndex(v => v.id === matchingVariant.id)
        : -1;
      if (!swatchImageUrl && variantIndex !== -1 && productData.variants_metafields && productData.variants_metafields[variantIndex]) {
        const variantMeta = productData.variants_metafields[variantIndex];
        if (variantMeta.custom && variantMeta.custom.swatch) {
          const customSwatch = variantMeta.custom.swatch.value || variantMeta.custom.swatch;
          swatchImageUrl = normalizeSwatchUrl(customSwatch);
        }
      }
      
      // Priority 2: Use the fabric option value swatch
      if (!swatchImageUrl) {
        const fabricValueObj = fabricOptionsData.values.find(v => v.name === fabricValue);
        if (fabricValueObj && fabricValueObj.swatch && fabricValueObj.swatch.image != null) {
          swatchImageUrl = normalizeSwatchUrl(fabricValueObj.swatch.image);
        }
      }
      
      // Priority 3: Use variant featured image as fallback (when metafield is null)
      if (!swatchImageUrl && matchingVariant && matchingVariant.featured_image && matchingVariant.featured_image.src) {
        swatchImageUrl = normalizeSwatchUrl(matchingVariant.featured_image.src);
      }
      
      // If we have a swatch URL, update the swatch element
      if (swatchImageUrl) {
        if (swatchSpan) {
          // Ensure URL has proper format
          let finalUrl = swatchImageUrl;
          
          // Handle Shopify CDN URLs - add width parameter if needed
          if (finalUrl.includes('cdn.shopify.com') || finalUrl.includes('/cdn/shop/')) {
            const urlParts = finalUrl.split('?');
            const baseUrl = urlParts[0];
            const searchParams = new URLSearchParams(urlParts[1] || '');
            
            if (!searchParams.has('width')) {
              searchParams.set('width', '100');
            }
            
            finalUrl = `${baseUrl}?${searchParams.toString()}`;
          }
          
          // Add cache busting parameter to force reload
          const cacheBuster = Date.now();
          finalUrl += (finalUrl.includes('?') ? '&' : '?') + `cb=${cacheBuster}`;
          
          const currentStyle = swatchSpan.getAttribute('style') || '';
          
          // Update the background image URL
          let newStyle;
          if (currentStyle.includes('--swatch--background:')) {
            newStyle = currentStyle.replace(
              /--swatch--background:\s*url\(['"]?[^'")\s]+['"]?\)/gi,
              `--swatch--background: url('${finalUrl}')`
            );
          } else {
            // Add it if not present
            newStyle = currentStyle + ` --swatch--background: url('${finalUrl}');`;
          }
          
          // Remove any background-image property that might have been added
          newStyle = newStyle.replace(/background-image:\s*url\([^)]*\)\s*;?/gi, '');
          
          swatchSpan.setAttribute('style', newStyle);
          updatedCount++;
        }
      }
    });

    if (isAutoResettingFabric) {
      return;
    }

    const fabricOptionElements = Array.from(swatchElements).filter(isFabricOptionElement);
    if (fabricOptionElements.length === 0) {
      return;
    }

    const selectedFabricOption = fabricOptionElements.find((optionEl) => {
      const input = getOptionInput(optionEl);
      return !!(input && input.checked);
    });

    if (!selectedFabricOption || isValidFabricOption(selectedFabricOption)) {
      return;
    }

    const currentVariantInput = document.querySelector('input[name="id"], select[name="id"]');
    const currentVariantId = currentVariantInput && currentVariantInput.value ? String(currentVariantInput.value) : '';
    const initialVariantId = window.__INITIAL_VARIANT_FROM_URL ? String(window.__INITIAL_VARIANT_FROM_URL) : '';
    if (initialVariantId && currentVariantId === initialVariantId) {
      return;
    }

    const firstValidFabricOption = fabricOptionElements.find(isValidFabricOption);
    if (!firstValidFabricOption) {
      return;
    }

    const inputToSelect = getOptionInput(firstValidFabricOption);
    if (!inputToSelect || inputToSelect.checked) {
      return;
    }

    isAutoResettingFabric = true;
    inputToSelect.click();
    window.setTimeout(() => {
      isAutoResettingFabric = false;
    }, 0);
  }
  
  // Handler function for option changes
  function handleOptionChange(target) {
    if (!target || !target.matches) return;
    
    // SKIP shop collection items - they have their own handler
    if (target.closest('.shop-collection__item')) {
      return;
    }
    
    if (target.matches('input[name^="options["]') || target.matches('.swatch-input__input')) {
      const optionName = target.name.match(/options\[([^\]]+)\]/)?.[1] || '';
      
      // Cleanup immediately first
      cleanupSwatchBackgroundImages();
      
      // Only trigger updateFabricSwatchImages if not changing fabric/color itself
      if (!optionName.toLowerCase().includes('fabric') && !optionName.toLowerCase().includes('color')) {
        setTimeout(() => {
          updateFabricSwatchImages();
        }, 200);
      }
    }
  }
  
  // Listen to ALL option changes
  document.addEventListener('change', (e) => {
    handleOptionChange(e.target);
  });
  
  // ALSO listen to clicks on option inputs for immediate response
  document.addEventListener('click', (e) => {
    const target = e.target;
    
    // Check if clicked on an option label or input
    const optionInput = target.closest('.product-options__option-value, .swatch-input__label, label[for^="Option"]');
    if (optionInput) {
      // Find the actual input element
      let inputEl = null;
      if (target.matches('input[name^="options["]')) {
        inputEl = target;
      } else if (optionInput.querySelector('input[name^="options["]')) {
        inputEl = optionInput.querySelector('input[name^="options["]');
      } else {
        // Try to find input by label's for attribute
        const label = target.closest('label');
        if (label && label.getAttribute('for')) {
          inputEl = document.getElementById(label.getAttribute('for'));
        }
      }
      
      if (inputEl && inputEl.name && inputEl.name.includes('options[')) {
        const optionName = inputEl.name.match(/options\[([^\]]+)\]/)?.[1] || '';
        
        // Cleanup immediately
        cleanupSwatchBackgroundImages();
        
        // Only trigger updateFabricSwatchImages if not clicking fabric/color itself
        if (!optionName.toLowerCase().includes('fabric') && !optionName.toLowerCase().includes('color')) {
          // Trigger immediately on click
          setTimeout(() => {
            updateFabricSwatchImages();
          }, 100);
        }
      }
    }
  });
  
  // Also listen to clicks on swatches directly
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.swatch, .swatch--square, .swatch-input__label');
    if (swatch) {
      setTimeout(() => {
        cleanupSwatchBackgroundImages();
      }, 50);
    }
  });
  
  // Also trigger on variant change events
  document.addEventListener('flu:product:variant-change', () => {
    setTimeout(() => {
      cleanupSwatchBackgroundImages();
      updateFabricSwatchImages();
    }, 200);
  });
  
  document.addEventListener('variant:changed', () => {
    setTimeout(() => {
      cleanupSwatchBackgroundImages();
      updateFabricSwatchImages();
    }, 200);
  });
  
  // Trigger cleanup immediately and multiple times to catch all swatches
  cleanupSwatchBackgroundImages();
  
  // Cleanup again after a short delay to catch dynamically added swatches
  setTimeout(cleanupSwatchBackgroundImages, 100);
  setTimeout(cleanupSwatchBackgroundImages, 250);
  
  // Trigger on initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      cleanupSwatchBackgroundImages();
      setTimeout(() => {
        cleanupSwatchBackgroundImages();
        updateFabricSwatchImages();
      }, 300);
      setTimeout(cleanupSwatchBackgroundImages, 600);
    });
  } else {
    cleanupSwatchBackgroundImages();
    setTimeout(() => {
      cleanupSwatchBackgroundImages();
      updateFabricSwatchImages();
    }, 300);
    setTimeout(cleanupSwatchBackgroundImages, 600);
  }
  
  window.addEventListener('load', () => {
    cleanupSwatchBackgroundImages();
    setTimeout(() => {
      cleanupSwatchBackgroundImages();
      updateFabricSwatchImages();
    }, 500);
    setTimeout(cleanupSwatchBackgroundImages, 1000);
  });
  
  // Add MutationObserver to catch dynamically added/modified swatches
  const observer = new MutationObserver((mutations) => {
    let hasSwatchChanges = false;
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        const target = mutation.target;
        if (target.classList.contains('swatch') || target.classList.contains('swatch--square')) {
          hasSwatchChanges = true;
        }
      } else if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && (
            node.classList?.contains('swatch') || 
            node.classList?.contains('swatch--square') ||
            node.querySelector?.('.swatch, .swatch--square')
          )) {
            hasSwatchChanges = true;
          }
        });
      }
    });
    
    if (hasSwatchChanges) {
      cleanupSwatchBackgroundImages();
    }
  });
  
  // Start observing
  if (document.body) {
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true
    });
  }
})();

// Enable touch swipe for mobile devices on product gallery
(function () {
  'use strict';

  let retryCount = 0;
  const maxRetries = 5; // Maximum 5 retries (2.5 seconds total)

  function enableMobileSwipe() {
    // First check if product gallery element exists at all
    const productGalleryContainer = document.querySelector('.product-gallery__main');

    // If no product gallery container found, this is not a product page - exit silently
    if (!productGalleryContainer) {
      return;
    }

    const mainSwiperEl = productGalleryContainer.querySelector('.swiper');

    // If swiper element doesn't exist or swiper not initialized yet
    if (!mainSwiperEl || !mainSwiperEl.swiper) {
      retryCount++;

      // Only retry if we haven't exceeded max retries
      if (retryCount < maxRetries) {
        setTimeout(enableMobileSwipe, 500);
      }
      return;
    }

    const mainSwiper = mainSwiperEl.swiper;

    // Function to check if device is mobile
    function isMobileDevice() {
      return window.innerWidth <= 600;
    }

    // Enable touch for mobile devices
    function updateSwiperTouchSettings() {
      if (isMobileDevice()) {
        // Enable touch/swipe gestures on mobile
        if (mainSwiper.params) {
          mainSwiper.params.allowTouchMove = true;
          mainSwiper.params.simulateTouch = true;
          mainSwiper.params.touchRatio = 1;
          mainSwiper.params.touchAngle = 45;
          mainSwiper.params.grabCursor = true;
          mainSwiper.allowTouchMove = true;
          mainSwiper.update();
        }
      } else {
        // Keep touch enabled for desktop too (in case of touch screens)
        if (mainSwiper.params) {
          mainSwiper.params.allowTouchMove = true;
          mainSwiper.allowTouchMove = true;
        }
      }
    }

    // Initial setup
    updateSwiperTouchSettings();

    // Update on window resize
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateSwiperTouchSettings, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableMobileSwipe);
  } else {
    enableMobileSwipe();
  }
})();

/**
 * Tabs Functionality
 * Direct JavaScript conversion from TypeScript tabs.directive.ts
 * Handles tab switching with tab-trigger and tab-content attributes
 * 
 * USAGE:
 * <div tabs>
 *   <button tab-trigger="tab-1">Tab 1</button>
 *   <button tab-trigger="tab-2">Tab 2</button>
 *   <div tab-content="tab-1">Content 1</div>
 *   <div tab-content="tab-2">Content 2</div>
 * </div>
 */
(function initTabs() {
  // Find all elements with [tabs] attribute
  const tabsContainers = document.querySelectorAll('[tabs]');

  tabsContainers.forEach(container => {
    // Get all triggers and content elements
    const triggers = container.querySelectorAll('[tab-trigger]');
    const contents = container.querySelectorAll('[tab-content]');

    if (triggers.length === 0 || contents.length === 0) {
      return;
    }

    // Initialize - activate first tab (TypeScript master onAppInit behavior)
    const firstTrigger = triggers[0];
    const firstContent = contents[0];

    if (firstTrigger) {
      firstTrigger.classList.add('is-active');
      firstTrigger.setAttribute('aria-selected', 'true');
    }

    if (firstContent) {
      firstContent.classList.add('is-active');
    }

    // Bind click events to triggers (TypeScript master bindEvents behavior)
    triggers.forEach(trigger => {
      trigger.addEventListener('click', (event) => {
        // Don't prevent default for links (like print tear sheet)
        if (trigger.tagName === 'A' && trigger.hasAttribute('href')) {
          return;
        }

        event.preventDefault();

        const tabId = trigger.getAttribute('tab-trigger');
        if (!tabId) return;

        // Find matching content
        const tabContent = container.querySelector(`[tab-content="${tabId}"]`);
        if (!tabContent) return;

        // Remove active class from all triggers
        triggers.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        // Remove active class from all contents
        contents.forEach(c => {
          c.classList.remove('is-active');
        });

        // Add active class to clicked trigger and matching content
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-selected', 'true');
        tabContent.classList.add('is-active');
      });
    });
  });
})();
/**
 * Truncate Toggle Functionality
 * Direct JavaScript conversion from TypeScript toggle-truncate.directive.ts
 * Handles show more/less functionality for truncated text
 * 
 * USAGE:
 * <div truncate>
 *   <div truncate-text class="truncated">Long text...</div>
 *   <button truncate-btn>Show More</button>
 * </div>
 */
(function initTruncate() {
  /**
   * @param {ParentNode} [root=document]
   */
  function bindTruncateContainers(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const truncateContainers =
      root && root.nodeType === 1 && root.matches('[truncate]')
        ? [root]
        : scope.querySelectorAll('[truncate]');

    truncateContainers.forEach((container) => {
      if (!(container instanceof HTMLElement) || container.dataset.abchomeTruncateInit === '1') {
        return;
      }

      const truncateText = container.querySelector('[truncate-text]');
      const truncateBtn = container.querySelector('[truncate-btn]');

      if (!truncateText || !truncateBtn) {
        return;
      }

      container.dataset.abchomeTruncateInit = '1';

      // Get translation text from button's initial content or data attributes
      // Preserve the original button text (which should have translation applied via Liquid)
      const originalButtonText = truncateBtn.textContent.trim() || truncateBtn.innerHTML.trim();
      const showMoreText = truncateBtn.dataset.showMore || originalButtonText || 'Show More';
      const showLessText =
        truncateBtn.dataset.showLess ||
        originalButtonText.replace(/more/i, 'less').replace(/Show/i, 'Show') ||
        'Show Less';

      // Initialize - check if text needs truncation
      const init = () => {
        if (
          truncateText.offsetHeight < truncateText.scrollHeight ||
          truncateText.offsetWidth < truncateText.scrollWidth
        ) {
          // Text is truncated, show button
          truncateBtn.style.display = 'inline-block';
          truncateBtn.style.pointerEvents = 'all';
        } else {
          // Text fits, hide button
          truncateBtn.style.display = 'none';
          truncateBtn.style.pointerEvents = 'none';
          truncateText.classList.remove('truncated');
        }
      };

      // Click handler
      truncateBtn.addEventListener('click', () => {
        const isTruncated = truncateText.classList.contains('truncated');

        if (isTruncated) {
          // Expand - remove truncated class
          truncateText.classList.remove('truncated');
          truncateBtn.innerHTML = showLessText;
        } else {
          // Contract - add truncated class
          truncateText.classList.add('truncated');
          truncateBtn.innerHTML = showMoreText;
        }
      });

      // Resize handler with debounce
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (!truncateText.classList.contains('truncated')) {
            truncateText.classList.add('truncated');
          }
          init();
        }, 150);
      });

      // Initial check
      init();
    });
  }

  window.ABCHOME_initTruncateIn = bindTruncateContainers;
  bindTruncateContainers(document);
})();

(function initShareWidgets() {
  const shareWidgets = document.querySelectorAll('.share-widget');

  shareWidgets.forEach((widget) => {
    const toggle = /** @type {HTMLButtonElement | null} */ (widget.querySelector('.share-widget__toggle'));
    const options = /** @type {HTMLElement | null} */ (widget.querySelector('.share-widget__options'));
    const links = options ? options.querySelectorAll('.share-widget__link') : [];

    if (!toggle || !options || links.length === 0) {
      return;
    }

    // Initialize - hide links and set initial styles
    links.forEach((link) => {
      const linkEl = /** @type {HTMLElement} */ (link);
      linkEl.style.visibility = 'hidden';
      linkEl.style.opacity = '0';
      linkEl.style.transform = 'translate(0px, 50px)';
      linkEl.style.transition = 'all 0.3s ease';
    });

    // Set initial state
    options.hidden = true;

    // Toggle functionality
    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      const newExpanded = !isExpanded;

      toggle.setAttribute('aria-expanded', newExpanded.toString());

      if (newExpanded) {
        // Expand - show widget and animate links
        const widgetEl = /** @type {HTMLElement} */ (widget);
        widgetEl.style.width = 'auto';
        options.hidden = false;

        // Animate links in with stagger
        links.forEach((link, index) => {
          const linkEl = /** @type {HTMLElement} */ (link);
          setTimeout(() => {
            linkEl.style.visibility = 'inherit';
            linkEl.style.opacity = '1';
            linkEl.style.transform = 'translate(0px, 0px)';
            linkEl.style.transitionDelay = `${index * 0.05}s`;
          }, 10);
        });
      } else {
        // Collapse - animate links out and hide widget
        links.forEach((link) => {
          const linkEl = /** @type {HTMLElement} */ (link);
          linkEl.style.visibility = 'hidden';
          linkEl.style.opacity = '0';
          linkEl.style.transform = 'translate(0px, 50px)';
          linkEl.style.transitionDelay = '0s';
        });

        // Hide widget after animation
        setTimeout(() => {
          const widgetEl = /** @type {HTMLElement} */ (widget);
          widgetEl.style.width = '';
          options.hidden = true;
        }, 300);
      }
    });

    const showCopiedFeedback = (linkEl) => {
      linkEl.classList.add('share-widget__link--copied');
      setTimeout(() => {
        linkEl.classList.remove('share-widget__link--copied');
      }, 2000);
    };

    // Handle copy functionality
    links.forEach((link) => {
      const option = link.getAttribute('data-share-option');

      if (option === 'copy') {
        link.addEventListener('click', (e) => {
          e.preventDefault();

          const linkEl = /** @type {HTMLElement} */ (link);

          // Copy to clipboard
          if (navigator.clipboard) {
            navigator.clipboard.writeText(window.location.href).then(() => {
              showCopiedFeedback(linkEl);
            }).catch(() => {
              // Fallback if clipboard API fails
            });
          } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = window.location.href;
            textArea.style.position = 'fixed';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.select();
            try {
              document.execCommand('copy');
              showCopiedFeedback(linkEl);
            } catch (err) {
              // Failed to copy
            }
            document.body.removeChild(textArea);
          }
        });
      }
    });
  });

  // Close share widgets when clicking outside
  document.addEventListener('click', (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    if (!target.closest('.share-widget')) {
      shareWidgets.forEach((widget) => {
        const toggle = /** @type {HTMLButtonElement | null} */ (widget.querySelector('.share-widget__toggle'));
        if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
          toggle.click(); // Trigger toggle to close
        }
      });
    }
  });
})();

(function articleShareWidget() {
  document.addEventListener("click", function (e) {
    const shareButton = e.target.closest(".product__share");
    if (!shareButton) return;
    shareButton.classList.toggle("active");
  });
})();

(function initVariantUpdate() {
  const swatchInputs = document.querySelectorAll('.swatch-input__input');

  swatchInputs.forEach((element) => {
    const radioInput = /** @type {HTMLInputElement} */ (element);

    // Safety check
    if (!radioInput) return;

    radioInput.addEventListener('change', (e) => {
      const parentSwatchDiv = /** @type {HTMLElement} */ (radioInput.closest('.product-options__option-value'));
      const productForm = radioInput.closest('form');

      if (parentSwatchDiv && productForm) {
        const variantId = parentSwatchDiv.dataset.variantId;
        const atcBTN = productForm.querySelector('[type="button"][add-to-cart]');

        if (atcBTN && variantId) {
          atcBTN.setAttribute('add-to-cart', variantId);
        }
      }
    });
  });
})();
(function initQuantitySelectors() {
  const quantityWrappers = document.querySelectorAll('.product-form__quantity');

  quantityWrappers.forEach((wrapper) => {
    // SKIP shop collection items - they have their own handler
    if (wrapper.closest('.shop-collection__item')) {
      return;
    }
    
    // Type casting elements correctly
    const input = /** @type {HTMLInputElement} */ (wrapper.querySelector('.product-form__input--quantity'));
    const plusBtn = /** @type {HTMLElement} */ (wrapper.querySelector('.product-form__quantity-add-item'));
    const minusBtn = /** @type {HTMLElement} */ (wrapper.querySelector('.product-form__quantity-subtract-item'));

    // Safety check
    if (!input || !plusBtn || !minusBtn) {
      return;
    }

    /** * Helper function to update value
     * @param {number} change 
     */
    const updateQuantity = (change) => {
      let currentValue = parseInt(input.value) || 0;
      let newValue = currentValue + change;

      if (newValue < 1) newValue = 1;

      input.value = newValue.toString();
      input.dispatchEvent(new Event('change'));
    };

    plusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      updateQuantity(1);
    });

    minusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      updateQuantity(-1);
    });
  });
})();

(function initSmoothScroll() {
  const scrollTriggers = document.querySelectorAll(
    ".shop-collection__scrollto, .shop-collection__scrollto_mobile, .product-metas__excerpt-jump-link"
  );

  scrollTriggers.forEach((element) => {
    const trigger = /** @type {HTMLElement} */ (element);

    trigger.addEventListener("click", function (e) {
      const targetSelector = trigger.getAttribute("scroll-to");
      if (!targetSelector) {
        return;
      }

      const targetSection = document.querySelector(targetSelector);
      if (!targetSection) {
        return;
      }

      e.preventDefault();
      targetSection.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });
  });
})();

(function() {
  // Accordion toggle functionality
  document.querySelectorAll('.product-accordion-description__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const contentId = this.getAttribute('aria-controls');
      const content = document.getElementById(contentId);
      const isOpen = this.getAttribute('aria-expanded') === 'true';

      // Close all other accordions
      document.querySelectorAll('.product-accordion-description__trigger').forEach(function(otherTrigger) {
        if (otherTrigger !== trigger) {
          const otherContentId = otherTrigger.getAttribute('aria-controls');
          const otherContent = document.getElementById(otherContentId);
          otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherContent) {
            otherContent.hidden = true;
          }
        }
      });

      // Toggle current accordion
      this.setAttribute('aria-expanded', !isOpen);
      if (content) {
        content.hidden = isOpen;
      }
    });
  });

  // Sync accordion details with existing-product-tabs
  function syncAccordionDetails() {
    // Try multiple selectors to find source details
    const sourceSelectors = [
      '.existing-product-tabs .additional-details',
      '.product-tabs .additional-details',
      '.product-tabs__content-column--details .additional-details',
      '.wrapper.existing-product-tabs .additional-details'
    ];
    
    const targetSelector = '.product-accordion-description__content-column--details .additional-details';
    const accordionDetailsContainer = document.querySelector(targetSelector);
    
    if (!accordionDetailsContainer) {
      return false;
    }

    // Find source details from any of the possible locations
    let existingDetails = null;
    for (let selector of sourceSelectors) {
      existingDetails = document.querySelector(selector);
      if (existingDetails && existingDetails.innerHTML.trim()) {
        break;
      }
    }

    if (existingDetails && existingDetails.innerHTML.trim()) {
      const sourceHTML = existingDetails.innerHTML.trim();
      const currentHTML = accordionDetailsContainer.innerHTML.trim();
      
      // Only update if different
      if (sourceHTML !== currentHTML) {
        accordionDetailsContainer.innerHTML = sourceHTML;
        return true;
      } else {
        return true;
      }
    }
    
    return false;
  }

  // Watch for changes in existing-product-tabs
  function initSync() {
    const targetSelector = '.product-accordion-description__content-column--details .additional-details';
    const accordionDetailsContainer = document.querySelector(targetSelector);
    
    if (!accordionDetailsContainer) {
      // Retry after a delay if container not found
      setTimeout(initSync, 500);
      return;
    }

    // Initial sync - try multiple times
    let syncAttempts = 0;
    const maxAttempts = 10;
    const trySync = setInterval(function() {
      syncAttempts++;
      if (syncAccordionDetails() || syncAttempts >= maxAttempts) {
        clearInterval(trySync);
      }
    }, 200);

    // Watch for changes using MutationObserver on multiple containers
    const sourceSelectors = [
      '.existing-product-tabs',
      '.product-tabs',
      '.product-tabs__content-column--details',
      '.wrapper.existing-product-tabs'
    ];

    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
          // Check if additional-details was modified
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.classList && node.classList.contains('additional-details') || node.querySelector('.additional-details'))) {
              shouldUpdate = true;
            }
          });
          mutation.removedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.classList && node.classList.contains('additional-details'))) {
              shouldUpdate = true;
            }
          });
          shouldUpdate = true;
        }
        if (mutation.type === 'characterData') {
          shouldUpdate = true;
        }
        if (mutation.type === 'attributes') {
          shouldUpdate = true;
        }
      });
      if (shouldUpdate) {
        // Debounce sync
        clearTimeout(window.accordionSyncTimeout);
        window.accordionSyncTimeout = setTimeout(function() {
          syncAccordionDetails();
        }, 100);
      }
    });

    // Observe all possible source containers
    sourceSelectors.forEach(function(selector) {
      const container = document.querySelector(selector);
      if (container) {
        observer.observe(container, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden']
        });
      }
    });

    // Also watch the additional-details element directly
    const existingDetails = document.querySelector('.existing-product-tabs .additional-details') || 
                            document.querySelector('.product-tabs .additional-details') ||
                            document.querySelector('.product-tabs__content-column--details .additional-details');
    if (existingDetails) {
      observer.observe(existingDetails, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true
      });
    }

    // Listen for variant change events (common in Shopify)
    document.addEventListener('variant:change', function() {
      setTimeout(syncAccordionDetails, 300);
    });

    // Listen for any custom events that might update product details
    document.addEventListener('product:updated', function() {
      setTimeout(syncAccordionDetails, 300);
    });
  }

  // Initialize after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initSync, 100);
    });
  } else {
    setTimeout(initSync, 100);
  }
  
  // Also try after a longer delay to catch late-loaded content
  setTimeout(initSync, 500);
  setTimeout(initSync, 1000);
  setTimeout(initSync, 2000);
  
  // Force sync on window load
  window.addEventListener('load', function() {
    setTimeout(initSync, 500);
  });
})();

// PDP Gallery: Add Sample button click handler - triggers hidden upsell button
document.addEventListener("click", function(event) {
  const button = event.target.closest('.custom-sample-button[data-context="pdp-gallery"]');
  if (!button) return;
  
  if (button.disabled || button.dataset.processing === 'true') {
    return;
  }
  
  event.stopPropagation();
  event.preventDefault();
  
  const originalButtonText = button.textContent;
  button.textContent = 'Adding...';
  button.disabled = true;
  button.dataset.processing = 'true';
  
  const upsellButton = document.querySelector(".custom-rug-upsell .upsellTile__ctaButton, .custom-rug-upsell--pdp .upsellTile__ctaButton");
  
  if (upsellButton) {
    if (upsellButton.disabled) {
      button.textContent = 'Unavailable';
      setTimeout(() => {
        button.textContent = originalButtonText;
        button.disabled = false;
        button.dataset.processing = 'false';
      }, 2000);
      return;
    }
    
    upsellButton.click();
    
    setTimeout(() => {
      button.textContent = '✓ Added';
      setTimeout(() => {
        button.textContent = originalButtonText;
        button.disabled = false;
        button.dataset.processing = 'false';
      }, 1500);
    }, 500);
  } else {
    button.textContent = 'Not Available';
    setTimeout(() => {
      button.textContent = originalButtonText;
      button.disabled = false;
      button.dataset.processing = 'false';
    }, 2000);
  }
});